import { useState } from "react";
import Modal from "../../../modal/modal";
import TableCstm from "../../../TableCstm/TableCstm";
import './groupStudentsList.scss'

const GroupStudentsList = ({ isOpen, onClose, teacherClass }) => {
  if (!isOpen || !teacherClass) return null;

  // Configuración de columnas 
  const columns = [
    { header: "Nombre", accessor: "name", className: "tableCtype5" },
    { header: "Celular", accessor: "phone_number", className: "tableCtype2" },
    { header: "Teléfono fijo", accessor: "phone_number_home", className: "tableCtype2" },
    { header: "Teléfono Oficina", accessor: "phone_number_office", className: "tableCtype2" },
    { header: "Fecha de inscripción", accessor: "inscription_date", className: "tableCtype2" },
    { header: "Edad", accessor: "student_age", className: "tableCtype2" }

  ];
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="group-students-container">
        <div className="group-students-header">
          <h2 className="title-2">{teacherClass.name || "Maestro no asignado"}</h2>
          <span>Correo electrónico: {teacherClass.email || "Unknown"}</span>
          <br />
          <span>Teléfono: {teacherClass.phoneNumber || "Unknown"}</span>
          <br />
          <span>Recepcionistas: </span>
          {teacherClass.receptionist_in_charge.length === 0 ? (
            <strong>No cuenta con recepcionista encargado</strong>
          ) : (
            <div className="receptionist-list">
              {teacherClass.receptionist_in_charge.map((r) => (
                <div key={r.id} className="receptionist-item">
                  <strong>{r.name}</strong>
                  <span>{r.contact.phoneNumber}</span>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="group-students-list">
          <h1 className="title-1">Lista de Alumnos</h1>
          {
            teacherClass.students ?
              <>
                <TableCstm
                  columns={columns}
                  data={teacherClass.students}
                  classN="gs-table"
                />

                <div className="students-total">
                  <strong>Total de alumnos: {teacherClass.students_qty ?? 0}</strong>
                </div>
              </>
              :
              <p>
                Algo salio mal
              </p>
          }
        </div>
      </div>
    </Modal>
  );
};

export default GroupStudentsList;